import React, { useState } from 'react';

import DescriptionIcon from '@mui/icons-material/Description';
import MailIcon from '@mui/icons-material/Mail';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { IconButton, MenuItem, Stack, Tooltip, Popover, MenuList } from '@mui/material';

function HelpMenu() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selected, setSelected] = useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setSelected(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setSelected(false);
  };
  return (
    <>
      <Tooltip title="Help" arrow placement="bottom" sx={{ display: 'flex' }}>
        <IconButton
          onClick={handleClick}
          color="inherit"
          disableRipple
          sx={{
            borderRadius: '0',
            '&:hover': { backgroundColor: 'primary.main' },
            backgroundColor: selected ? 'primary.main' : '',
            minHeight: '100%',
          }}
          aria-controls={open ? 'help-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <QuestionMarkIcon />
        </IconButton>
      </Tooltip>
      <Popover
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        {...{
          transformOrigin: { horizontal: 'right', vertical: 'top' },
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        }}
        slotProps={{
          root: {
            id: 'help-menu',
          },
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
      >
        <MenuList>
          <MenuItem
            onClick={handleClose}
            href="mailto:helpdesk@morganlewis.com?subject=GEC%20Support%20Request"
            component="a"
          >
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center', flexWrap: 'nowrap' }}>
              <MailIcon />
              <span>Support</span>
            </Stack>
          </MenuItem>
          <MenuItem
            onClick={handleClose}
            href="https://mlprod.sharepoint.com/sites/MNFirmAdministration/Shared%20Documents/Training%20Resources/QRG%20Global%20Events%20Calendar.pdf"
            component="a"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center', flexWrap: 'nowrap' }}>
              <DescriptionIcon />
              <span>QRG</span>
            </Stack>
          </MenuItem>
        </MenuList>
      </Popover>
    </>
  );
}

export default HelpMenu;
